import { useEffect } from "react";
import Swal from "sweetalert2";

import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import Skeletontable from "../employee/skeletonTable";
import { useModal } from "../../../customHooks/useModal";
import { getRoles, getSkills } from "../../../store/roles_skills";
import Modal from "../../../components/modal";
import { BsSearch } from "react-icons/bs";
import useField from "../../../customHooks/useField";
import { IoIosAddCircleOutline } from "react-icons/io";
import OneRole from "./oneRole";
import NewRole from "./new/newRole";
import { useNavigate } from "react-router-dom";
import Footertable from "../../../components/pagination/footerPagination";

// import Footertable from "../employee/footerTable";

const Roles = () => {
  const navigate = useNavigate();
  const { isShown: isModalShown, toggle: ToggleModal } = useModal();

  const dispatch = useAppDispatch();
  const { status, roles, current_page, prev_page_url, next_page_url } =
    useAppSelector((state) => state.roles_skills);
  const { skills } = useAppSelector((state) => state.user);

  const search = useField({
    type: "text",
    name: "search",
    placeholder: "Search Role by Name or Slug",
  });

  const searchAction = () => {
    dispatch(getRoles({ page: 1, search: search.value }));
  };

  const onSearchKey = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      dispatch(getRoles({ page: 1, search: search.value }));
    }
  };

  useEffect(() => {
    dispatch(getSkills({ page: 1 }));
    dispatch(getRoles({ page: 1 }));
  }, [dispatch]);

  useEffect(() => {
    if (
      !skills.includes("super.admin") &&
      !skills.includes("publlic.users.roles.manage")
    ) {
      navigate("/");
    }
  }, [skills]);

  useEffect(() => {
    if (status === "updateRole_success") {
      dispatch(getRoles({ page: 1, search: search.value }));
      Swal.fire({ title: "Role Updated", icon: "success" });
    } else if (status === "newRole_success") {
      dispatch(getRoles({ page: 1, search: search.value }));
      Swal.fire({ title: "Role Created", icon: "success" });
    } else if (status === "deleteRole_success") {
      dispatch(getRoles({ page: 1, search: search.value }));
      Swal.fire({ title: "Role deleted", icon: "success" });
    } else if (status === "addSkillsRole_success") {
      dispatch(getRoles({ page: 1, search: search.value }));
      Swal.fire({ title: "Skills added", icon: "success" });
    }
  }, [status]);

  return (
    <>
      <Modal isActive={isModalShown} clouse={ToggleModal} title="New Role">
        <NewRole toggle={ToggleModal} isShown={isModalShown} />
      </Modal>
      <div className="c-table">
        <div className="c-table__header">
          <div className="c-table__box-options">
            <label className="c-table__search">
              <BsSearch />
              <input {...search} onKeyDown={(e) => onSearchKey(e)} />
            </label>
            <button
              className="c-table__button-secondary"
              onClick={searchAction}
            >
              Search
            </button>
          </div>
          <div className="c-table__box-options">
            <button
              type="button"
              className="c-table__button-secondary"
              onClick={ToggleModal}
            >
              <IoIosAddCircleOutline />
              New Role
            </button>
          </div>
        </div>
        <table className="c-table__content">
          <thead>
            <tr>
              <td className="c-table__trheead">ID</td>
              <td className="c-table__trheead">Role</td>
              <td className="c-table__trheead">Slug</td>
              <td className="c-table__trheead">Permisions</td>
              <td className="c-table__trheead">Actions</td>
            </tr>
          </thead>
          <tbody>
            {status === "getRoles_pending" && (
              <>
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
              </>
            )}
            {status !== "getRoles_pending" &&
              roles.map((role) => (
                <OneRole key={role.id_encrypted} role={role} />
              ))}
          </tbody>
        </table>
        <Footertable
          current_page={current_page}
          prev_page_url={prev_page_url}
          next_page_url={next_page_url}
          method={getRoles}
          status={status}
          search={search.value}
        />
      </div>
    </>
  );
};

export default Roles;
